import { render, staticRenderFns } from "./class-catalogue.vue?vue&type=template&id=74d529e0&scoped=true"
import script from "./class-catalogue.vue?vue&type=script&lang=js"
export * from "./class-catalogue.vue?vue&type=script&lang=js"
import style0 from "./class-catalogue.vue?vue&type=style&index=0&id=74d529e0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74d529e0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('74d529e0')) {
      api.createRecord('74d529e0', component.options)
    } else {
      api.reload('74d529e0', component.options)
    }
    module.hot.accept("./class-catalogue.vue?vue&type=template&id=74d529e0&scoped=true", function () {
      api.rerender('74d529e0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/detail-pane/class-catalogue.vue"
export default component.exports